import { ReactNode } from "react";

export interface OptionItemProps {
    bgColor?: string;
    color?: string;
    label?: ReactNode;
    children?: ReactNode;
}

export const OptionItem = ({
    bgColor = "#E8F4FF",
    color = "#0265FF",
    label,
    children,
}: OptionItemProps
) => {
    return (
        <div
            className="flex items-center justify-center gap-1.5 px-1.5 h-[26px] rounded-[100px] text-[13px]"
            style={{
                backgroundColor: bgColor,
                color: color,
            }}
        >
            {label || children}
        </div>
    )
}